"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var react_native_1 = require("react-native");
var DateTimePickerTypeEnum_1 = require("../enums/DateTimePickerTypeEnum");
var ATLAtomTextInput_1 = require("../atoms/ATLAtomTextInput");
var IOSKeyboardDate_1 = require("../components/IOSKeyboardDate");
var defaultProps = {
    complementary: false,
    disabled: false,
    required: false,
    type: DateTimePickerTypeEnum_1.DateTimePickerTypeEnum.date,
    textInputBaseProps: {}
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var rightArrow = require('../assets/next_white.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.InputWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n\tpadding:  ", "px\n\t          ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingAtomic;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingInputMarginHorizontal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLDateTimePicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, errorText = _a.errorText, helpText = _a.helpText, leftIcon = _a.leftIcon, title = _a.title, showFormattedDate = _a.showFormattedDate, showFormattedTime = _a.showFormattedTime, complementary = _a.complementary, disabled = _a.disabled, required = _a.required, type = _a.type, maxDate = _a.maxDate, minDate = _a.minDate, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, textInputBaseProps = _a.textInputBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var _b = react_1.useState(false), iOSModalVisible = _b[0], setIOSModalVisible = _b[1];
    var _c = react_1.useState(undefined), val = _c[0], setVal = _c[1];
    // Android date spinner component
    var androidDate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, action, year, month, day, selectedDate;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, react_native_1.DatePickerAndroid.open({
                        mode: 'spinner',
                        minDate: minDate,
                        maxDate: maxDate
                    })];
                case 1:
                    _a = _b.sent(), action = _a.action, year = _a.year, month = _a.month, day = _a.day;
                    if (action === react_native_1.DatePickerAndroid.dateSetAction) {
                        selectedDate = new Date;
                        selectedDate.setFullYear(year);
                        selectedDate.setMonth(month);
                        selectedDate.setDate(day);
                        onChange && onChange(selectedDate);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Android time spinner component
    var androidTime = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, action, hour, minute, selectedTime;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, react_native_1.TimePickerAndroid.open({
                        is24Hour: true,
                        mode: 'spinner'
                    })];
                case 1:
                    _a = _b.sent(), action = _a.action, hour = _a.hour, minute = _a.minute;
                    if (action === react_native_1.TimePickerAndroid.timeSetAction) {
                        selectedTime = new Date;
                        selectedTime.setMinutes(minute);
                        selectedTime.setHours(hour);
                        onChange && onChange(selectedTime);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Function that shows android modal depending on type
    var showAndroidModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = type;
                    switch (_a) {
                        case DateTimePickerTypeEnum_1.DateTimePickerTypeEnum.time: return [3 /*break*/, 1];
                        case DateTimePickerTypeEnum_1.DateTimePickerTypeEnum.date: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, androidTime()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, androidDate()];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Function that shows iOS modal
    var showIOSModal = function () {
        setIOSModalVisible(true);
    };
    // Function that hides iOS modal
    var hideIOSModal = function () {
        setIOSModalVisible(false);
    };
    // Renders TextInput
    var renderTextInput = function () { return (react_1.default.createElement(ATLAtomTextInput_1.ATLAtomTextInput, __assign({ value: value ? showDateTime(value) : '', onChange: onChange, onPressRightButton: react_native_1.Platform.OS === 'ios' ? showIOSModal : showAndroidModal, title: title, errorText: errorText, helpText: helpText, rightButtonIcon: rightArrow, leftIcon: leftIcon, disabled: disabled, disabledText: true, required: required, hideClearButton: true, boxColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast, errorColor: theme.ColorDanger, focusColor: theme.ColorInfo, labelColor: complementary ? theme.ColorComplementary1 : theme.ColorLowContrast, leftIconColor: theme.ColorBrand1Default }, textInputBaseProps))); };
    // Default function that converts date into text to show on textInput. Can be overrided by showFormattedDate/Time
    var showDateTime = react_1.useCallback(function (date) {
        if (type === DateTimePickerTypeEnum_1.DateTimePickerTypeEnum.date) {
            if (showFormattedDate)
                return showFormattedDate(date);
            return (('0' + date.getDate()).slice(-2) + "/" + ('0' + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear());
        }
        else {
            if (showFormattedTime)
                return showFormattedTime(date);
            return (('0' + date.getHours()).slice(-2) + ":" + ('0' + date.getMinutes()).slice(-2));
        }
    }, [value]);
    // Returns complete ATLDateTimePicker
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(exports.InputWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
            react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: react_native_1.Platform.OS === 'ios' ? showIOSModal : showAndroidModal },
                react_1.default.createElement(react_native_1.View, null,
                    renderTextInput(),
                    react_1.default.createElement(react_native_1.View, null, react_native_1.Platform.OS === 'ios' &&
                        react_1.default.createElement(IOSKeyboardDate_1.IOSKeyboardDate, { modalVisible: iOSModalVisible, handleClose: hideIOSModal },
                            react_1.default.createElement(react_native_1.DatePickerIOS, { date: value || val || new Date(), onDateChange: onChange || setVal, mode: type === DateTimePickerTypeEnum_1.DateTimePickerTypeEnum.date ? 'date' : 'time', maximumDate: maxDate, minimumDate: minDate }))))))));
};
exports.ATLDateTimePicker.defaultProps = defaultProps;
exports.ATLDateTimePicker.displayName = 'ATLDateTimePicker';
var templateObject_1;
